<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'PrintTypeList' }">Print Types</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form 
      ref="print_type" 
      :model="print_type"
      :rules="rules.print_type"
      :label-position="label_position">

      <el-form-item label="Name" prop="name">
          <el-input v-model="print_type.name"></el-input>
      </el-form-item>

       <el-form-item>
          <el-button type="primary" @click="updatePrintType('print_type')">Update</el-button>
        </el-form-item>
    </el-form>

    <pre>{{$data}}</pre>
  </div>
</template>

<style>
</style>

<script>
  import Config from '@/store/Config.js';
  export default {
    data: function() {
      return { 
        config: Config.config,
        page_alias: 'Edit Print Type',
        page_slug: 'edit-print-type',
        label_position: 'top',
        
        rules: {
          print_type: {
            name: [
              { required: true, message: 'Please Enter Name', trigger: 'blur' }
            ],
          }
        },

        print_type: {
          name:''
        },
      };
    },

    mounted: function() {
      const me = this;
      me.getPrintType();
    },

    methods: {
      getPrintType: function() {
        console.log('Get Print Type Function');
        const me = this;
        me.$http.get(me.config.api + 'printType/{id}', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.print_type = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      updatePrintType: function(formName) {
        console.log('Update Print Type Function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            me.$http.put(me.config.api + 'printType/{id}', me.print_type, {params: {id : me.$route.params.id}}).then(
              response => {
              console.log('Success Putting Data')  
              console.log(response.status);
              console.log(response.statusText);

              me.getPrintType();
              
              me.$notify({
                title: 'Success',
                message: 'The Print Type Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Error Putting Data');
              console.log(response.status);
              console.log(response.statusText);
              console.log(response.bodyText);
          });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/print-types/PrintTypeEdit.vue